import { fetchGetApi } from "./fetch";

export const getPrograms = async () => {
  const res = await fetchGetApi("/programs/public");
  return res;
};
